import firebase from "firebase/compat/app";
import "firebase/compat/messaging";
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCdlIitHzPkYaQzjZz5zd_aQalpLNdCmX0",
  authDomain: "ez-cloud-c8683.firebaseapp.com",
  projectId: "ez-cloud-c8683",
  storageBucket: "ez-cloud-c8683.appspot.com",
  messagingSenderId: "1044122700090",
  appId: "1:1044122700090:web:f2d325f415af0f59312803",
  measurementId: "G-53WQTJWNFG",
};
firebase.initializeApp(firebaseConfig);

const messaging = firebase.messaging();
const REACT_APP_VAPID_KEY =
  "BFW-YbgD9hPwrIfPUylcs6U6YmzjsGV1JBobq8gA2OyJ6az0Be0IxlFOCcacUdn-Yf77uHJ5USIT5PhbiEqCBNY";

export const getToken = async (setTokenFound: (found: boolean) => void): Promise<string | null> => {
  try {
    const currentToken = await messaging.getToken({ vapidKey: REACT_APP_VAPID_KEY });
    if (currentToken) {
      setTokenFound(true);
    } else {
      setTokenFound(false);
    }
    return currentToken;
  } catch (_error) {
    return null;
  }
};

export const onMessageListener = (): Promise<unknown> =>
  new Promise((resolve) => {
    messaging.onMessage((payload: unknown) => {
      resolve(payload);
    });
  });
